import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import { gapi } from 'gapi-script';
//import FacebookLogin from 'react-facebook-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import $ from 'jquery';

function Login() { 

    const history = useHistory();

    const [loginInfo, setLoginInfo] = useState({
        email: '',
        password: ''
    });

    const [errors, setErrors] = useState({});
    const [disable, setDisable] = useState(false);

    const InputEvent = (e) => {

        const newLoginInfo = { ...loginInfo };

        var check = onlySpaces(e.target.value);
        if(check == false){
            newLoginInfo[e.target.name] = e.target.value;
            setLoginInfo(newLoginInfo);
        }else{
            newLoginInfo[e.target.name] = "";
            setLoginInfo(newLoginInfo);
        }

    }

    function onlySpaces(str) {
        return str.trim().length === 0;
      }

    const submitHandler = (e) => {
        e.preventDefault();
        if (validate()) {
            setDisable(true);
            const { email, password } = loginInfo;

            const myurl = "https://events.teambuildingawards.com:3000/api/web/login";
            var bodyFormData = new URLSearchParams();
            bodyFormData.append('email', email);
            bodyFormData.append('password', password);
            axios({
                method: "post",
                url: myurl,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            }).then((response) => {
                console.log(response);
                if (response.data.type == 1) {
                    setDisable(false);
                    localStorage.setItem('TBA_CLIENT_ID', response.data.data.host_id);
                    localStorage.setItem('TBA_CLIENT_EMAIL', response.data.data.email);
                    localStorage.setItem('TBA_CLIENT_PHONE_NUMBER', response.data.data.phone_number);
                    localStorage.setItem('TBA_CLIENT_NAME', response.data.data.first_name+' '+response.data.data.last_name);
                    localStorage.setItem('TBA_CLIENT_IMAGE', response.data.data.image);
                   // toast.success("Login Successfully...!");
                    $(".tba-modal-close-btn").click();

                    setLoginInfo({
                        email: '',
                        password: ''
                    });

                    history.push(`/`);
                //    setTimeout(() => {
                //     window.location.reload();
                //   }, 1000);
                   
                } else if(response.data.type == 2) {
                    setDisable(false);
                    toast.error(response.data.message);
                }else if(response.data.type == 4) {
                    setDisable(false);
                    toast.error(response.data.message);
                }else{
                    $(".tba-modal-close-btn").click();
                    setDisable(false);
                    toast.success(response.data.message);
                    $(".show-tbaOTPModal").click();

                    localStorage.setItem('TBA_CLIENT_EMAIL', response.data.data.email);
                    localStorage.setItem('TBA_CLIENT_PHONE_NUMBER', response.data.data.phone_number);
                    localStorage.setItem('TBA_CLIENT_NAME', response.data.data.first_name+' '+response.data.data.last_name);
                    localStorage.setItem('TBA_CLIENT_IMAGE', '/assets/images/user-img.png');
                }

            }).catch((error) => {
                console.log("Errors", error);
            })


        }
    }

    const validate = () => {
        let input = loginInfo;

        let errors = {};
        let isValid = true;

        if (!input["email"]) {
            isValid = false;
            errors["email_err"] = "Please enter email";
        }
        if (!input["password"]) {
            isValid = false;
            errors["password_err"] = "Please enter password";
        }

        setErrors(errors);
        return isValid;
    }

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
        cpassword: '',
        company_name: '',
        type: '1',
        social_id: '',
        accept:'',
      });

    // useEffect(()=>{
    //     function start(){
    //         gapi.client.init({
    //             clientId:"594187405864-c2qpbub5lrb6ruaqvb3006sbuh2jvc0q.apps.googleusercontent.com",
    //             scop: ""
    //         });
    //     }
    //     gapi.load('client:auth2',start);

    //   });

      const responseGoogleFail = (response) => {
        console.log(response);
      }

      const responseGoogle = (response) => {
        console.log(response);

        const myurl = "https://events.teambuildingawards.com:3000/api/web/register";
            var bodyFormData = new URLSearchParams();
            bodyFormData.append('first_name', response.profileObj.name);
            bodyFormData.append('last_name', "");
            bodyFormData.append('email', response.profileObj.email);
            bodyFormData.append('phone_number', "");
            bodyFormData.append('type', '2');
            bodyFormData.append('social_id', response.profileObj.googleId);
            axios({
                method: "post",
                url: myurl,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            }).then((response) => {
                console.log(response);
                if (response.data.success == true) {

                    localStorage.setItem('TBA_CLIENT_EMAIL', response.data.data.email);
                    localStorage.setItem('TBA_CLIENT_PHONE_NUMBER', "");
                    localStorage.setItem('TBA_CLIENT_NAME', response.data.data.name);
                    localStorage.setItem('TBA_CLIENT_ID', response.data.data.host_id);
                    localStorage.setItem('TBA_CLIENT_IMAGE', '/assets/images/user-img.png');
                    
                   // toast.success(response.data.message);
                    setDisable(false);

                    $(".tba-modal-close-btn").click();

                    setFormData({
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone_number: '',
                        password: '',
                        cpassword: '',
                        company_name: '',
                        type: '1',
                        social_id: '',
                        accept: '',
                    });
                    
                    setTimeout(() => {
                        $(".tba-modal-close-btn").click();
                        window.location.reload();
                      }, 2000);

                }else{
                    toast.error(response.data.message);
                    setDisable(false);
                }
            }).catch((error) => {
                console.log("Errors", error);
                setDisable(false);
            })

      }

      const responseFacebook = (response) => {
        console.log(response);

        if(response.status != "unknown"){
        const myurl = "https://events.teambuildingawards.com:3000/api/web/register";
            var bodyFormData = new URLSearchParams();
            bodyFormData.append('first_name', response.name);
            bodyFormData.append('last_name', "");
            bodyFormData.append('email', response.email);
            bodyFormData.append('phone_number', "");
            bodyFormData.append('type', '3');
            bodyFormData.append('social_id', response.userID);
            axios({
                method: "post",
                url: myurl,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            }).then((response) => {
                console.log(response);
                if (response.data.success == true) {

                    localStorage.setItem('TBA_CLIENT_EMAIL', response.data.data.email);
                    localStorage.setItem('TBA_CLIENT_PHONE_NUMBER', "");
                    localStorage.setItem('TBA_CLIENT_NAME', response.data.data.name);
                    localStorage.setItem('TBA_CLIENT_ID', response.data.data.host_id);
                    localStorage.setItem('TBA_CLIENT_IMAGE', '/assets/images/user-img.png');
                    
                   // toast.success(response.data.message);
                    setDisable(false);

                    $(".tba-modal-close-btn").click();

                    setFormData({
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone_number: '',
                        password: '',
                        cpassword: '',
                        company_name: '',
                        type: '1',
                        social_id: '',
                        accept: '',
                    });
                    
                    setTimeout(() => {
                        $(".tba-modal-close-btn").click();
                        window.location.reload();
                      }, 2000);

                }else{
                    toast.error(response.data.message);
                    setDisable(false);
                }
            }).catch((error) => {
                console.log("Errors", error);
                setDisable(false);
            })
        }
      }

    return (
        <>
                <div className="modal fade" id="tbaLoginModal" tabindex="-1" aria-labelledby="tbaLoginModalLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <span data-bs-dismiss="modal" aria-label="Close" className="tba-modal-close-btn">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M25.4279 6.57187C22.9096 4.05353 19.5612 2.66666 15.9998 2.66666C12.4384 2.66666 9.0901 4.05353 6.57176 6.57192C4.05343 9.09025 2.6665 12.4385 2.6665 16C2.6665 19.5615 4.05338 22.9098 6.57171 25.4282C9.09005 27.9464 12.4383 29.3333 15.9998 29.3333C19.5612 29.3333 22.9096 27.9464 25.4279 25.4281C27.9462 22.9097 29.3332 19.5614 29.3332 16C29.3332 12.4385 27.9462 9.09025 25.4279 6.57187ZM24.3231 24.3233C22.0998 26.5464 19.1439 27.7708 15.9998 27.7708C12.8557 27.7708 9.89973 26.5464 7.67656 24.3233C5.45333 22.1 4.229 19.1442 4.229 16C4.229 12.8559 5.45343 9.89999 7.67661 7.67676C9.89984 5.45353 12.8557 4.22916 15.9998 4.22916C19.144 4.22916 22.0998 5.45353 24.3231 7.67671C28.9124 12.2662 28.9124 19.7338 24.3231 24.3233Z"
                                fill="#FFFFFB" />
                            <path
                                d="M21.8775 20.773L17.1046 16L21.8775 11.2271C22.1826 10.922 22.1826 10.4273 21.8775 10.1223C21.5724 9.81718 21.0777 9.81718 20.7726 10.1223L15.9997 14.8952L11.2267 10.1222C10.9217 9.81713 10.427 9.81713 10.1219 10.1222C9.81679 10.4273 9.81679 10.922 10.1219 11.2271L14.8949 16L10.1219 20.773C9.81679 21.0781 9.81679 21.5728 10.1219 21.8779C10.2744 22.0304 10.4744 22.1067 10.6743 22.1067C10.8742 22.1067 11.0742 22.0304 11.2267 21.8779L15.9997 17.1049L20.7727 21.8779C20.9252 22.0304 21.1252 22.1067 21.3251 22.1067C21.5251 22.1067 21.725 22.0304 21.8775 21.8779C22.1826 21.5728 22.1826 21.0781 21.8775 20.773Z"
                                fill="#FFFFFB" />
                        </svg>
                    </span>
                </div>
                <div className="modal-body">
                    <div className="tba-modal-content">
                        <div className="tba-modal-logo">
                            <img src="/assets/images/logo-dark.png" alt="logo-dark" className="img-fluid" />
                        </div>
                        <div className="tba-modal-heading">
                            <h2 className="tba-modal-title">Welcome Back...</h2>
                            <p className="tba-modal-description">Please enter your email and password.</p>
                        </div>
                        <form onSubmit={(e) => submitHandler(e)} >
                        <div className="tba-login-content">
                            <div className="tba-login-form">
                                <div className="row">
                                    <div className="col col-12 col-md-12">
                                        <label for="inputEmail" className="form-label">Email <span style={{color:"red"}}>*</span></label>
                                        <input type="email" name="email" className="form-control" autoComplete="off" placeholder="Enter Your email" onChange={InputEvent} value={loginInfo.email} />
                                        <div className="text-danger">{errors.email_err}</div>
                                    </div>
                                    <div className="col col-12 col-md-12">
                                        <label for="inputpasswprd" className="form-label">Password <span style={{color:"red"}}>*</span></label>
                                        <input type="password" name="password" className="form-control"
                                            placeholder="Enter Your password" autoComplete="off" onChange={InputEvent} value={loginInfo.password} />
                                            <div className="text-danger">{errors.password_err}</div>
                                        <div className="text-end">
                                            <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
                                                data-bs-toggle="modal" data-bs-target="#tbaResetPasswordModal"
                                                className="tba-forgot-pass-link">Forgot Password?</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tba-login-option">
                                <div className="tba-login-option-devider">
                                    <span className="tba-login-option-devider-text">Or</span>
                                </div>

                                <ul className="tba-login-option-list">
                                {/* <FacebookLogin
  appId="382614183838001"
  callback={responseFacebook}
  autoLoad={false}
  fields="name,email,picture"
  scope="public_profile,user_friends"
  render={renderProps => (
    <li className="tba-login-option-item">
        <a href="javascript:void(0);" onClick={renderProps.onClick} disabled={renderProps.disabled} className="tba-login-option-link">
            <svg width="29" height="28" viewBox="0 0 29 28" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_246_1648)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M18.1356 9.324L16.8179 9.32487C15.7845 9.32487 15.5841 9.81575 15.5841 10.5359V12.1249H18.049L17.7279 14.6143H15.5841V21H13.0142V14.6143H10.8652V12.1249H13.0142V10.29C13.0142 8.15938 14.3154 7 16.215 7C17.125 7 17.9073 7.06738 18.1356 7.098V9.324ZM14.5 0C6.7685 0 0.5 6.26762 0.5 14C0.5 21.7315 6.7685 28 14.5 28C22.2324 28 28.5 21.7315 28.5 14C28.5 6.26762 22.2324 0 14.5 0Z"
                        fill="#3B5998" />
                </g>
                <defs>
                    <clipPath id="clip0_246_1648">
                        <rect width="28" height="28" fill="white"
                            transform="translate(0.5)" />
                    </clipPath>
                </defs>
            </svg>
        </a>
    </li>
  )}
/> */}
                                    
        <GoogleLogin
    clientId="594187405864-c2qpbub5lrb6ruaqvb3006sbuh2jvc0q.apps.googleusercontent.com"
    render={renderProps => (
        <li className="tba-login-option-item">
        <a href="javascript:void(0);" onClick={renderProps.onClick} disabled={renderProps.disabled} className="tba-login-option-link">
            <svg width="29" height="28" viewBox="0 0 29 28" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_246_1653)">
                    <path
                        d="M6.70539 16.9207L5.73075 20.5592L2.16846 20.6346C1.10386 18.66 0.5 16.4008 0.5 14C0.5 11.6785 1.06459 9.4892 2.06538 7.56152H2.06614L5.23758 8.14296L6.62686 11.2954C6.33609 12.1431 6.1776 13.0531 6.1776 14C6.17771 15.0277 6.36387 16.0123 6.70539 16.9207Z"
                        fill="#FBBB00" />
                    <path
                        d="M28.2552 11.3846C28.416 12.2315 28.4998 13.1062 28.4998 14C28.4998 15.0023 28.3945 15.98 28.1937 16.9231C27.5122 20.1323 25.7314 22.9346 23.2645 24.9177L23.2637 24.917L19.2691 24.7131L18.7038 21.1839C20.3407 20.2239 21.6199 18.7216 22.2938 16.9231H14.8076V11.3846H22.403H28.2552Z"
                        fill="#518EF8" />
                    <path
                        d="M23.2638 24.9169L23.2646 24.9177C20.8654 26.8461 17.8177 28 14.5 28C9.16846 28 4.53309 25.02 2.16846 20.6346L6.70539 16.9208C7.88768 20.0761 10.9315 22.3223 14.5 22.3223C16.0338 22.3223 17.4708 21.9077 18.7038 21.1838L23.2638 24.9169Z"
                        fill="#28B446" />
                    <path
                        d="M23.4362 3.22306L18.9008 6.93613C17.6247 6.13845 16.1162 5.67766 14.5001 5.67766C10.8508 5.67766 7.75003 8.02687 6.62697 11.2954L2.0662 7.56153H2.06543C4.39545 3.06923 9.08927 0 14.5001 0C17.897 0 21.0116 1.21002 23.4362 3.22306Z"
                        fill="#F14336" />
                </g>
                <defs>
                    <clipPath id="clip0_246_1653">
                        <rect width="28" height="28" fill="white"
                            transform="translate(0.5)" />
                    </clipPath>
                </defs>
            </svg>
        </a>
    </li>
    )}
    buttonText="Login"
    onSuccess={responseGoogle}
    onFailure={responseGoogle}
    cookiePolicy={'single_host_origin'}
    scope="profile"
  />
                                    {/* <li className="tba-login-option-item">
                                        <a href="#" className="tba-login-option-link">
                                            <svg width="29" height="28" viewBox="0 0 29 28" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_246_1658)">
                                                    <path
                                                        d="M22.1725 15.6951C21.4023 11.8188 25.0815 9.5454 25.0815 9.5454C25.0815 9.5454 23.648 7.47148 21.2389 6.93795C18.8309 6.40325 17.6258 7.0713 16.4229 7.57236C15.219 8.07464 14.6182 8.07464 14.6182 8.07464C12.8807 8.07464 11.6106 6.23502 8.30031 7.07253C6.01973 7.64806 3.61894 10.2807 3.18518 13.4229C2.75141 16.5662 3.68746 20.5771 5.49221 23.6856C7.29697 26.7965 9.13542 27.9656 10.4403 27.9992C11.7452 28.0317 13.0477 27.0644 14.6182 26.8289C16.1899 26.5958 17.1571 27.3985 18.6987 27.8322C20.2343 28.2648 20.7727 27.8635 22.5414 26.3591C24.3149 24.8547 25.9202 20.5399 25.9202 20.5399C25.9202 20.5399 22.9427 19.5737 22.1725 15.6951Z"
                                                        fill="black" />
                                                    <path
                                                        d="M18.7622 4.43019C20.4684 2.69156 19.8904 0 19.8904 0C19.8904 0 17.4945 0.420565 15.8892 2.09074C14.2851 3.76214 14.5506 6.402 14.5506 6.402C14.5506 6.402 17.0559 6.16771 18.7622 4.43019Z"
                                                        fill="black" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_246_1658">
                                                        <rect width="28" height="28" fill="white"
                                                            transform="translate(0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                            <button type="submit" className="btn btn-primary" disabled={disable}>{disable ? 'Processing...' : 'Login'}</button>
                            <p className="tba-modal-notes">Don’t have an account? <a href="javascript:void(0);"
                                    data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal"
                                    data-bs-target="#tbaRegisterModal">Register Now</a></p>
                        </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
  
        </>
    )
}

export default Login
